<template>
  <div class="company-info-page">
    <!-- 基本资料 -->
    <a-card title="企业信息" :bordered="false">
      <div class="base-info">
        <!-- <div class="info-line"><span class="label">用户名：</span>000150241687</div> -->
        <div class="info-line"><span class="label">企业名称：</span>上海新金山农商实业发展集团有限公司</div>
        <div class="info-line"><span class="label">统一社会信用代码：</span>9913101161342286419</div>
      </div>
    </a-card>

    <!-- 账号设置 -->
    <a-card title="账号设置" style="margin-top: 24px;" :bordered="false">
      <div v-for="item in settings" :key="item.key" class="setting-item">
        <!-- 状态点+说明 -->
        <div class="left">
          <span :class="['status-dot', item.statusColor]"></span>
          <span class="main-text">{{ item.title }}</span>
          <span class="sub-text">{{ item.description }}</span>
        </div>

        <!-- 右侧公司名或时间 -->
        <div class="center" v-if="item.extra">{{ item.extra }}</div>

        <!-- 操作按钮 -->
        <div class="right">
          <a-button v-if="item.action === 'edit'" type="default" size="small">修改</a-button>
          <a-button v-else type="primary" size="small">更新</a-button>
        </div>
      </div>
    </a-card>
  </div>
</template>




<script>
export default {
  data() {
    return {
      settings: [
        {
          key: 'cert',
          title: '企业认证',
          description: '以企业身份参与项目',
          statusColor: 'blue',
          extra: '上海金山商业发展（集团）有限公司',
          action: 'update'
        },
        {
          key: 'license',
          title: '证件有效',
          description: '证件有效的截止日期',
          statusColor: 'blue',
          extra: '长期有效',
          action: 'update'
        },
        {
          key: 'auth',
          title: '授权有效',
          description: '授权有效的截止日期',
          statusColor: 'blue',
          extra: '2025-12-31',
          action: 'update'
        },
        {
          key: 'agreement',
          title: '合作协议',
          description: '上传后方可正常使用',
          statusColor: 'gray',
          extra: '',
          action: 'update'
        },
        {
          key: 'password',
          title: '切换密码',
          description: '保障登录密码安全使用',
          statusColor: 'blue',
          extra: '',
          action: 'edit'
        }
      ]
    };
  }
};


</script>

<style scoped>
.company-info-page {
  padding: 8px;
}

.base-info {
  padding: 8px 16px;
  line-height: 32px;
  font-size: 14px;
}

.info-line .label {
  display: inline-block;
  width: 160px;
  font-weight: bold;
  color: #555;
}

.setting-item {
  display: flex;
  align-items: center;
  padding: 14px 8px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.setting-item:last-child {
  border-bottom: none;
}

.left {
  flex: 1.5;
  display: flex;
  align-items: center;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 16px;
}

.status-dot.blue {
  background-color: #1890ff;
}

.status-dot.gray {
  background-color: #d9d9d9;
}

.main-text {
  font-weight: 500;
  margin-right: 200px;
}

.sub-text {
  color: #888;
}

.center {
  flex: 1;
  color: #888;
}

.right {
  width: 80px;
  text-align: right;
}


</style>